import React, { useState, useCallback, useEffect } from "react";
import { useFormikContext } from "formik";
import debounce from "lodash/debounce";
import { useTranslation } from "react-i18next";
import { FormikFormGroup } from "components/common";
import { Button, Input } from "components/bootstrap";
import { getS3ProviderCopy } from "archive/logic/s3CompatibleProviders";
const AWSKeySecretFieldGroup = ({ isAccesskeySet, handleAccessKeyChange, variant = "s3" }) => {
  const { t } = useTranslation("enterprise_archive");
  const { setFieldValue } = useFormikContext();
  const copy = getS3ProviderCopy(variant);
  const [isCreate] = useState(() => !isAccesskeySet);
  const [showResetPasswordButton, setShowResetPasswordButton] = useState(isAccesskeySet);
  const setAccessKey = useCallback(
    (nextAccessKey) => {
      setFieldValue("settings.aws_secret_access_key", nextAccessKey);
    },
    [setFieldValue]
  );
  useEffect(() => {
    if (isAccesskeySet) {
      setAccessKey({ keep_value: true });
    }
  }, [isAccesskeySet, setAccessKey]);
  const toggleAccessKeyReset = useCallback(() => {
    if (showResetPasswordButton) {
      setAccessKey({ delete_value: true });
      setShowResetPasswordButton(false);
      return;
    }
    setAccessKey({ keep_value: true });
    setShowResetPasswordButton(true);
  }, [setAccessKey, showResetPasswordButton]);
  const debouncedHanldeAccessKeyChange = debounce(handleAccessKeyChange, 200);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.aws_access_key_id",
      type: "text",
      label: copy.accessKeyLabel,
      placeholder: t("aws_key_secret_field_group.access_key_placeholder"),
      help: copy.accessKeyHelp,
      required: true
    }
  ), showResetPasswordButton ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "aws_secrete_key_reset",
      label: copy.secretKeyResetLabel,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Button, { onClick: toggleAccessKeyReset }, t("aws_key_secret_field_group.reset_password"))
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      name: "settings.aws_secret_access_key",
      id: "aws_secrete_key",
      type: "password",
      label: copy.secretKeyLabel,
      onChange: ({ target: { value } }) => debouncedHanldeAccessKeyChange(value),
      buttonAfter: !isCreate ? /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleAccessKeyReset }, t("aws_key_secret_field_group.undo_reset")) : void 0,
      placeholder: "****************",
      help: copy.secretKeyHelp,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  ));
};
export default AWSKeySecretFieldGroup;
